import { useFormContext } from 'react-hook-form';
import { Card } from '@shared/ui';
import { CustomEditorInputControlled } from '@src/modules/Authentication/InputsControlled';
import * as st from './styles.module.scss';

export const Places = (): JSX.Element => {
  const { control } = useFormContext();

  return (
    <fieldset>
      <div className={st.header}>
        <h3>Количество участников</h3>
      </div>
      <Card className={st.places}>
        <div className={st.places__input}>
          <CustomEditorInputControlled control={control} name="places" label="" />
        </div>
      </Card>
    </fieldset>
  );
};
